export default "__VITE_PUBLIC_ASSET__6c0ea406__"